import { render, staticRenderFns } from "./CreateMacAddressAttributeDialog.vue?vue&type=template&id=22fd4500&"
import script from "./CreateMacAddressAttributeDialog.vue?vue&type=script&lang=js&"
export * from "./CreateMacAddressAttributeDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VTextField,VTextarea})
